angular.module("vgresiduos").controller("productEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `unidades/produto/${$stateParams.id}`);
		};
	}
]);
